import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const SingleForm = dynamic(() => import('./SingleForm'));

Builder.registerComponent(SingleForm, {
	name: 'SingleForm',
	inputs: [
		{
			name: 'form',
			friendlyName: 'Form',
			type: 'reference',
			model: 'form',
			defaultValue: {
				'@type': '@builder.io/core:Reference',
				id: 'f86c3b6d48c94d8da964dd705d15438c',
				model: 'form',
			},
		},
		{
			name: 'showFinePrint',
			friendlyName: 'Show TCPA',
			type: 'boolean',
			defaultValue: true,
			helperText: `If true will show TCPA. TCPA is REQUIRED for any forms. 
			This option allows it to be removed from the first step`,
		},
		{
			name: 'showLogos',
			friendlyName: 'Show Logos',
			type: 'boolean',
			defaultValue: true,
			helperText: 'If TCPA text is shown this is an option to show or hide logos',
		},
		{
			name: 'finePrint',
			friendlyName: 'Fine Print',
			type: 'richText',
			required: false,
			defaultValue: `<p>
				By clicking &apos;Do I Qualify&apos; and submitting my request,
				I provide my electronic signature and consent to receive phone calls
				and/or text messages from Total Injury Help to the above telephone
				number containing offers to identify a lawyer in its network that may
				assist me. These communications may be generated using an autodialer,
				and/or pre-recorded or artificial voice, and that consent is not required
				to utilize Total Injury Help services. This authorization overrides any
				previous registrations on a federal or state Do Not Call registry. I agree
				to the <a href="/privacy-policy/" target="_blank" rel="noopener noreferrer">privacy policy</a>
				and <a href="/terms-of-use/" target="_blank" rel="noopener noreferrer">terms</a>
				(including mandatory arbitration and class waiver).
				</p>`,
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: 'transparent',
			helperText: 'Background color for the form wrapper',
		},
	],
	image: getIconUrl(Icon.FORM),
});
